import { AvatarUploads } from "@/components/avatar-uploads";
import { MyVoices } from "@/components/my-voices";
import { LinkButton } from "@/components/ui";

export const metadata = { title: "Avatars — EasyShot Studio" };

export default function AvatarsPage() {
  return (
    <div className="mx-auto max-w-5xl px-5 py-8 sm:py-10">
      <div className="mb-8 flex flex-wrap items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Avatars</h1>
          <p className="mt-2 text-sm text-muted">
            Your own photos, videos and voice recordings — saved to your account and available in Create.
          </p>
        </div>
        <LinkButton href="/studio">Use in a new video</LinkButton>
      </div>

      <AvatarUploads />
      <MyVoices />
    </div>
  );
}
